import OSS from "ali-oss";
import { get } from "./request";

let config = undefined;
const buildObjectUrl = (objectKey) => {
  if (!config || !objectKey) {
    return "";
  }

  const protocol = config?.secure === false ? "http" : "https";
  const bucket = config?.bucket || config?.bucketName;
  const region = `${config?.region || ""}`.replace(/^https?:\/\//, "").replace(/\/+$/, "");
  const encodedKey = `${objectKey}`
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");

  if (!bucket || !region) {
    return "";
  }

  if (region.includes(".aliyuncs.com")) {
    if (region.startsWith(`${bucket}.`)) {
      return `${protocol}://${region}/${encodedKey}`;
    }
    return `${protocol}://${bucket}.${region}/${encodedKey}`;
  }

  if (region.startsWith("oss-")) {
    return `${protocol}://${bucket}.${region}.aliyuncs.com/${encodedKey}`;
  }

  return `${protocol}://${region}/${encodedKey}`;
};
const GetCode = async () => {
  const res = await get("bluetoothlight/web/common/oss/auth");
  const data = res?.resultData;
  if (!data) {
    // oss 配置数据异常
    return false;
  }
  return {
    ...data,
    bucket: data?.bucketName,
    region: data?.bucketDomain,
    secure: true
  };
};
const client = (name, file, cancel) => {
  return new Promise(async (resolve, reject) => {
    if (!config) {
      config = await GetCode();
    }
    // if (!config) {
    //   reject("oss config invalid");
    //   return false;
    // }
    // const { bucketName, bucketDomain } = config;

    const client = new OSS({
      ...config,
      // bucket: bucketName,
      // region: bucketDomain,
      refreshSTSToken: GetCode
    });
    cancel && cancel(client.cancel)
    // 处理 client 的问题
    let res = undefined;
    try {
      res = await client.put(name, file);
      if (res) {
        const { name } = res;
        const url = buildObjectUrl(name) || res?.url?.split("?")?.[0];
        return resolve({ name, url });
      }
      else {
        return reject(res);
      }
    } catch (e) {
      reject(e);
    }
    resolve(res);
  });
};

const multipartUpload = (name, file, cancel,contextPath,callback) => {
  return new Promise(async (resolve) => {
    let res = undefined;
    if (!config) {
      config = await GetCode();
    }
    let newClient = new OSS({
      ...config,
      // bucket: bucket,
      // region: bucketDomain,
      refreshSTSToken: GetCode
    });
    try {
      if(!contextPath){
        contextPath = "bluetooth_light";
      }
      const objectKey = contextPath + "/" + name;
      res = await newClient.multipartUpload(objectKey, file, {
        progress: (p, checkpoint) => {
          if(callback){
            //回传上传进度
            callback(p);
          }
          if (cancel && checkpoint) {
            // cancel = newClient.abortMultipartUpload.bind(newClient, checkpoint.name, checkpoint.uploadId)
            cancel(newClient.abortMultipartUpload.bind(newClient, checkpoint.name, checkpoint.uploadId))
          }
        },
        timeout: 360000});
      const url = buildObjectUrl(res?.name || objectKey) || res?.res?.requestUrls?.[0]?.split("?")?.[0];
      if (!url) {
        return resolve({
          ...(res || {}),
          resultStatus: false
        });
      }
      else {
        return resolve({ resultStatus: true, name: res?.name, url });
      }
    } catch (e) {
      console.log(e);
      return resolve({
        ...(e || {}),
        resultStatus: false
      });
    }
  });
};



export { client, multipartUpload };
